import { ChangeEvent } from 'react';
import { handleTrack } from '../../../utils/tracker';
import { TextInput } from '../../Calculators/calculator-revamp/components/form-components/InputBox';
import {
  AtcLeftDeductionDetails,
  AtcRightDeductionDetails,
} from '../Atc-calculator-constants';
import { CALCULATOR_TAB_PROPS } from '../types';
import { removeCommas } from '../../Utils/CommonUtils';

const AtcDeductions = ({
  setGlobalError,
  setInputData,
  inputTabData,
}: CALCULATOR_TAB_PROPS) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const key = e.target.id;
    const value = removeCommas(e.target.value);
    handleTrack({ label: `ATC_Deductions_${key}` });
    setInputData?.((prev) => ({ ...prev, [key]: value }));
  };
  return (
    <>
      <div className="flex gap-12 sm:block font-medium">
        <div className="w-full">
          {AtcLeftDeductionDetails?.map((props, index) => (
            <TextInput
              key={index}
              {...props}
              value={`${inputTabData?.[props.id]}` || ''}
              setGlobalError={setGlobalError}
              onTextChangeFn={handleChange}
            />
          ))}
        </div>
        <div className="w-full">
          {AtcRightDeductionDetails?.map((props, index) => (
            <TextInput
              key={index}
              {...props}
              value={`${inputTabData?.[props.id]}` || ''}
              setGlobalError={setGlobalError}
              onTextChangeFn={handleChange}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default AtcDeductions;
